import React, { useEffect } from "react";
import { Box, Typography, Avatar, IconButton, Paper } from "@material-ui/core";
import NotificationPage from "../inAppNotification/Index";
import { makeStyles } from "@material-ui/core/styles";
import useFeeData from "../Dashboard/Components/useStudentData";
import store from "store";
import { motion, useAnimation } from "framer-motion";
import LogoURLMap from "../../components/LogoURLMap";

const useStyles = makeStyles((theme) => ({
  cardWrapper: {
    borderRadius: 18,
    overflow: "hidden",
    background: "linear-gradient(135deg, #2a469f 0%, #0005d9 100%)",
    position: "relative",
    margin: theme.spacing(1),
    padding: 0,
    boxShadow: "0 20px 40px rgba(0,0,0,0.15)",
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      background:
        "url('https://www.transparenttextures.com/patterns/subtle-dark-vertical.png')",
      opacity: 0.04,
    },
  },
  logo: {
    height: 70,
  },
  contentWrapper: {
    padding: theme.spacing(1),
  },
  header: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    marginBottom: theme.spacing(0.5),
  },
  userInfoBox: {
    display: "flex",
    alignItems: "center",
    position: "relative",
    zIndex: 2,
  },
  avatarWrapper: {
    borderRadius: "50%",
  },
  avatar: {
    width: 50,
    height: 50,
    border: "3px solid white",
  },
  nameDetails: {
    marginLeft: theme.spacing(1),
  },
  greeting: {
    fontSize: 14,
    fontWeight: 700,
    lineHeight: "1.2em",
    color: " #FFFFFF",
  },
  name: {
    fontSize: 16,
    fontWeight: 700,
    color: "white",
    lineHeight: "1.2em",
    background: "linear-gradient(90deg, #FFFFFF 0%, #E0F7FF 100%)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },
  id: {
    fontSize: 13,
    fontWeight: 700,
    color: "white",
    lineHeight: "1.2em",
    background: "linear-gradient(90deg, #FFFFFF 0%, #E0F7FF 100%)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },
  footer: {
    padding: theme.spacing(1, 0, 0),
    background: "rgba(255,255,255,0.15)",
    borderTop: "1px solid rgba(255,255,255,0.1)",
    borderRadius: "0 0 24px 24px",
  },
  branch: {
    fontSize: 16,
    fontWeight: 700,
    color: " #FFFFFF",
    display: "flex",
    alignItems: "center",
  },
}));

const BetterBadgeAvatars = () => {
  const classes = useStyles();
  const controls = useAnimation();
  const user = store.get("user") || {};
  const fullName = user.name || user.fullName || "Student Name";
  const userId = user.userId || "ID-0000";
  const instituteId = user.institute;
  const instituteInfo = instituteId ? LogoURLMap[instituteId] : null;
  const instituteName = instituteInfo ? instituteInfo.title : "Institute";

  const [, , stuFeeData, avatar, branchName] = useFeeData();
  console.log("stuFeeData", stuFeeData);

  const logoUrl =
    stuFeeData &&
    stuFeeData.branchData &&
    stuFeeData.branchData.images &&
    stuFeeData.branchData.images.receiptHeader
      ? stuFeeData.branchData.images.receiptHeader
      : "";

  useEffect(() => {
    controls.start({
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" },
    });
  }, [controls]);

  const containerVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        when: "beforeChildren",
        staggerChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 10 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5 },
    },
  };

  return (
    <>
      <Box display="flex" alignItems="center" justifyContent="center">
        {logoUrl && (
          <img src={logoUrl} alt="Institute Logo" className={classes.logo} />
        )}
      </Box>
      <motion.div
        initial="hidden"
        animate="visible"
        variants={containerVariants}
        className={classes.cardWrapper}
      >
        <div className={classes.contentWrapper}>
          <motion.div variants={itemVariants}>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              marginBottom={1}
            >
              <Typography
                fontSize={16}
                style={{
                  color: "white",
                  fontWeight: 700,
                }}
              >
                {instituteName}
              </Typography>
            </Box>
          </motion.div>
          <Box className={classes.header}>
            <motion.div variants={itemVariants} className={classes.userInfoBox}>
              <motion.div
                className={classes.avatarWrapper}
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{
                  type: "spring",
                  damping: 8,
                  stiffness: 100,
                  delay: 0.2,
                }}
              >
                <Avatar src={avatar} className={classes.avatar} />
              </motion.div>
              <motion.div
                variants={itemVariants}
                className={classes.nameDetails}
              >
                <Typography className={classes.greeting}>Hello,</Typography>
                <Typography className={classes.name}>{fullName}</Typography>
                <Typography className={classes.id}>{userId}</Typography>
              </motion.div>
            </motion.div>
            <motion.div variants={itemVariants}>
              <NotificationPage />
            </motion.div>
          </Box>
        </div>

        <motion.div
          className={classes.footer}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
        >
          <Box display="flex" alignItems="center" flexDirection="row" pl={1}>
            <Typography
              variant="subtitle1"
              style={{
                color: "white",
                fontWeight: 700,
              }}
            >
              Br:
            </Typography>
            <Typography className={classes.branch}>
              {branchName || "Computer Science"}
            </Typography>
          </Box>
        </motion.div>
      </motion.div>
    </>
  );
};

export default BetterBadgeAvatars;
